var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 379.14694,
    viewBox: "0 0 132.29165 100.31596",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(2.5329589e-6,-196.68398)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE1F5\\uE1F5\\uE1F5",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "123.08706665px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 27.73056984
    },
    id: "text3983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3991",
    style: {
      strokeWidth: 27.73056984
    },
    d: "m 98.565809,196.68398 v 12.30871 h 30.771771 v 6.03126 H 98.565809 v 12.30871 H 129.33758 V 271.644 c -1.9694,-1.60013 -4.67731,-2.58482 -7.87758,-2.58482 -12.18562,0 -21.909495,8.98535 -21.909495,18.58614 0,5.78509 4.677305,9.23153 10.708575,9.23153 9.84697,0 21.9095,-9.10844 22.03258,-18.46306 v -81.72981 z m -33.175812,0 v 12.30871 h 30.771767 v 6.03126 H 65.389997 v 12.30871 H 96.161764 V 271.644 c -1.969394,-1.60013 -4.677309,-2.58482 -7.877573,-2.58482 -12.185619,0 -21.909498,8.98535 -21.909498,18.58614 0,5.78509 4.677309,9.23153 10.708575,9.23153 9.846966,0 21.909498,-9.10844 22.032585,-18.46306 v -81.72981 z m -33.175808,0 v 12.30871 h 30.771767 v 6.03126 H 32.214189 v 12.30871 H 62.985956 V 271.644 c -1.969393,-1.60013 -4.677309,-2.58482 -7.877573,-2.58482 -12.185619,0 -21.909498,8.98535 -21.909498,18.58614 0,5.78509 4.677309,9.23153 10.708575,9.23153 9.846966,0 21.909498,-9.10844 22.032585,-18.46306 v -81.72981 z m -2.427121,75.08311 c -1.969393,-1.60013 -4.677309,-2.58483 -7.877573,-2.58483 -12.1856193,0 -21.9094975329589,8.98536 -21.9094975329589,18.58615 0,5.78509 4.6773085329589,9.23153 10.7085745329589,9.23153 9.846966,0 21.909498,-9.23153 22.032585,-18.46306 v -81.8529 h -2.954089 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsss);
export default __webpack_public_path__ + "static/media/ssss.3ee7efc3e575f9cbd6380af4a11035bf.svg";
export { ForwardRef as ReactComponent };